import React from 'react'

const ProductsCard = (props) => {
  return (
    <div className="col-lg-4 col-md-6 mb-2 Furniture_card">
       <div className="items">
          <img className="img-fluid mb-2 image" src={props.imgsrc} alt="Picture of a Furniture"></img>
          <h3 className="mb-4">{props.title}</h3>
       </div>
     <div className="buy_btn"><a className="button" href="#">Read more</a></div>
    </div>
  )
}

export default ProductsCard;